import { c as e } from "../../../index-34b1f277.js";
import { FloatingBarAnatomy as a } from "./FloatingBottomBar.anatomy.es.js";
const { definePartsStyle: t, defineMultiStyleConfig: o } = e(
  a.keys
), i = {
  default: t({
    container: {
      transition: {
        base: "all 0.2s ease-in-out",
        md: "all .1s ease-in-out"
      },
      '&[data-open="true"]': {
        transform: {
          md: "translate(-50%, 0px)"
        },
        bottom: {
          base: 0,
          md: "spacing-400"
        },
        transition: {
          base: "all 0.2s ease-in-out",
          md: "all .1s ease-in-out"
        }
      },
      bottom: {
        base: "-280px",
        md: "-40px"
      },
      width: {
        base: "100%",
        md: "auto"
      },
      left: {
        base: 0,
        md: "50%"
      },
      transform: {
        base: "unset",
        md: "translate(-50%, 0px)"
      },
      borderRadius: {
        base: 0,
        md: "radius-150"
      },
      justifyContent: {
        base: "center",
        md: "unset"
      }
    }
  }),
  mobile: t({
    container: {
      transition: "all 0.2s ease-in-out",
      '&[data-open="true"]': {
        bottom: 0,
        transition: "all 0.2s ease-in-out"
      },
      position: "absolute",
      bottom: "-280px",
      width: "100%",
      left: 0,
      transform: "unset",
      borderRadius: 0,
      justifyContent: "center"
    }
  })
}, n = t({
  container: {
    visibility: "hidden",
    '&[data-open="true"]': {
      visibility: "visible"
    },
    position: "fixed",
    backgroundColor: "white",
    borderColor: "primary.100",
    borderWidth: "1px",
    boxShadow: "100",
    display: "flex",
    flexDirection: "row"
  },
  divider: {
    backgroundColor: "primary.100"
  }
}), l = o({
  baseStyle: n,
  variants: i,
  defaultProps: {
    variant: "default"
  }
});
export {
  l as FloatingBottomBar
};
//# sourceMappingURL=FloatingBottomBar.es.js.map
